import React from 'react';
import { useHistory } from 'react-router';
import clsx from 'clsx';
import {
	Box,
	Card,
	CardActions,
	makeStyles,
	Typography,
} from '@material-ui/core';
import { ArrowForwardIos as ArrowForwardIosIcon } from '@material-ui/icons';
import layoutService from 'src/services/layoutService';

const useStyle = makeStyles(theme => ({
	root: {},
	container: {
		paddingBottom: `${theme.spacing(1)}px !important`
	},
	item: {
		padding: theme.spacing(2)
	}
}));

function Manage({ entity, loader, expired, className }) {
	const classes = useStyle();
	const history = useHistory();
	const contractLineId = entity?.id;

	function handleClick() {
		if(layoutService.isMobile())
			history.push(`/mobile/supply/${contractLineId}/self-readings`, { entity })
		else
			history.push(`/app/supply/${contractLineId}/self-readings`, { entity });
	}

	return (
		<Card className={clsx(classes.root, className)}>
			<CardActions>
				<Box
					my={2}
					mx={1}
					display="flex"
					alignItems="center"
					justifyContent="space-between"
					width="100%"
					onClick={handleClick}
					>
					<Typography variant="body1">Autoletture</Typography>

					<ArrowForwardIosIcon fontSize="small" color="disabled" />
				</Box>
			</CardActions>
		</Card>
	);
}

export default Manage;
